import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function BonusSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    id: 1,
    title: 'Adiós al aburrimiento — 52 planes mágicos y económicos',
    desc: 'Un plan distinto para cada semana del año. Nunca más "no sé qué hacer con los chicos".',
    image: 'https://cdn.magicpatterns.com/uploads/4gN5gQQqAHrk4h1ejTW1T8/BONO_2.png',
    emoji: '✨'
  }, {
    id: 2,
    title: 'Juegos para descubrir lo que tu hija realmente piensa y siente',
    desc: 'Dinámicas que abren conversaciones profundas que nunca tendrías de otra forma.',
    image: 'https://cdn.magicpatterns.com/uploads/odG8KduDRrvn4roiuPyHTQ/BONO_3.png',
    emoji: '🎲'
  }, {
    id: 3,
    title: '30 cosas que quiero que mi hija nunca olvide aunque yo no esté',
    desc: 'Mensajes del corazón que van a quedar guardados para siempre. Un regalo emocional único.',
    image: 'https://cdn.magicpatterns.com/uploads/skodB8V7Uu5t5qN4pYh45G/BONO_1.png',
    emoji: '💌'
  }, {
    id: 4,
    title: 'Abuelita, cuéntame tu historia',
    desc: 'Un libro para preservar las historias y la sabiduría de la abuela antes de que se pierdan.',
    image: 'https://cdn.magicpatterns.com/uploads/imQe53N76XbcTTBMTUGdfx/BONO_4.png',
    emoji: '👵'
  }, {
    id: 5,
    title: 'Abuelito, cuéntame tu historia',
    desc: 'Las historias y enseñanzas del abuelo, guardadas para las próximas generaciones.',
    image: 'https://cdn.magicpatterns.com/uploads/2SmVZXe5Pkf4wAPfxxDxxd/BONO_5.png',
    emoji: '👴'
  }, {
    id: 6,
    title: 'Mamá, cuéntame tu historia',
    desc: 'Un legado emocional que tus hijos van a atesorar cuando sean grandes.',
    image: 'https://cdn.magicpatterns.com/uploads/jUQ3rpm56X8dELsbsjaqep/BONO_6.png',
    emoji: '👩'
  }, {
    id: 7,
    title: 'Papá, cuéntame tu historia',
    desc: 'Tus memorias, tus valores, tu historia. Un regalo que trasciende generaciones.',
    image: 'https://cdn.magicpatterns.com/uploads/uVwNxNoXbh8ndv4cJGA7ob/BONO_7.png',
    emoji: '👨'
  }];
  return <section className="py-16 px-4 bg-gray-900 text-white border-y-8 border-yellow-400" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-15">
          <div className="text-center mb-12" data-id="element-16">
            <h2 className="text-3xl md:text-5xl font-black text-yellow-400 mb-4 drop-shadow-lg" data-id="element-17">
              🎁 Y ADEMÁS RECIBÍS 7 BONOS EXCLUSIVOS
            </h2>
            <p className="text-xl md:text-2xl font-bold text-white" data-id="element-18">
              Solo si accedés hoy. Mañana ya no estarán disponibles.
            </p>
          </div>

          <div className="space-y-8 mb-12" data-id="element-19">
            {bonuses.map(bonus => <div key={bonus.id} className="bg-white text-gray-900 rounded-2xl p-6 shadow-2xl relative border-4 border-yellow-400 overflow-hidden" data-id="element-20">
                {/* Ribbon */}
                <div className="absolute top-4 right-[-35px] bg-red-600 text-white font-black py-1 px-10 transform rotate-45 shadow-md" data-id="element-21">
                  GRATIS HOY
                </div>

                <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-22">
                  <button onClick={scrollToPricing} className="w-full md:w-1/3 flex-shrink-0 cursor-pointer hover:scale-105 transition-transform" data-id="element-23">
                    {bonus.image ? <img src={bonus.image} alt={`Bono ${bonus.id}`} className="w-[250px] h-[250px] object-contain mx-auto drop-shadow-xl" data-id="element-24" /> : <div className="w-[250px] h-[250px] mx-auto bg-gradient-to-br from-yellow-100 to-yellow-300 rounded-xl flex items-center justify-center shadow-inner border-2 border-yellow-400" data-id="element-25">
                        <span className="text-8xl drop-shadow-md" data-id="element-26">
                          {bonus.emoji}
                        </span>
                      </div>}
                  </button>

                  <div className="text-center md:text-left flex-1" data-id="element-27">
                    <div className="inline-block bg-yellow-400 text-black font-black px-3 py-1 rounded-md mb-3 text-sm uppercase tracking-wider" data-id="element-28">
                      🎁 Bono {bonus.id}
                    </div>
                    <h3 className="text-2xl font-black text-gray-900 mb-3 leading-tight" data-id="element-29">
                      {bonus.title}
                    </h3>
                    <p className="text-lg text-gray-600 mb-4 font-medium" data-id="element-30">
                      {bonus.desc}
                    </p>
                    <p className="inline-block bg-gray-100 px-4 py-2 rounded-lg text-sm font-bold text-gray-500 border border-gray-200" data-id="element-31">
                      Valor estimado:{' '}
                      <span className="line-through text-red-500" data-id="element-32">$5.000</span>{' '}
                      <span className="text-green-600 ml-1" data-id="element-33">¡GRATIS!</span>
                    </p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="max-w-md mx-auto" data-id="element-34">
            <CTAButton text="👉 QUIERO EL PACK CON LOS BONOS" size="sm" data-id="element-35" />
          </div>
        </motion.div>
      </div>
    </section>;
}